import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['boxItem', 'content'];

  toggle() {
    this.boxItemTarget.classList.toggle('boxItemComponent--opened');

    $(this.contentTarget).slideToggle({
      start: () => {
        if (
          !this.boxItemTarget.classList.contains('boxItemComponent--opened')
        ) {
          this.boxItemTarget.classList.add('boxItemComponent--slidingUp');
        }
      },
      done: () => {
        if (
          this.boxItemTarget.classList.contains('boxItemComponent--slidingUp')
        ) {
          this.boxItemTarget.classList.remove('boxItemComponent--slidingUp');
        }
      },
    });
  }
}
